module.exports = __webpack_public_path__ + "img/20240428-144015.a0172515.png";